import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../api";
import { createError } from "../../errors";
import { MessageNotificationInterface } from "../../interfaces/NotificationInterface";

type Props = {
  sectionId: string;
  enabled: boolean;
};
type ResponseBody = { messageNotifications: MessageNotificationInterface[] };
export const useFetchMessages = ({ sectionId, enabled }: Props) => {
  const path = `/api/v1/sections/${sectionId}/message_notifications`;
  return useQuery<ResponseBody, Error>({
    queryKey: [path],
    queryFn: async () => {
      const response = await ApiClient.get(path);
      if (response.ok) {
        const json = await response.json();
        return json;
      }
      throw await createError(response);
    },
    enabled,
  });
};
